export const capitalize = (word: string): string => {
  const newWord = word.toLowerCase().trim();
  return newWord.charAt(0).toUpperCase() + newWord.slice(1);
};
